<template>
    <div class="box" v-loading="loading">
        <div class="page">
            <div class="page-left">
                <div class="title">门头名称</div>
                <div class="border">
                    <input type="text" class="border-input" placeholder="请输入门头名称">
                </div>
                <div class="title mt16">行业类型</div>
                <div class="border">
                    <el-form-item class="form-item">
                        <el-select v-model="form.industry" placeholder="行业类型" :popper-append-to-body="false"
                            :teleported="false" class="material-select" style="width: 100%;" filterable allow-create>
                            <el-option v-for="item in industries" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </div>
                <div class="title mt16">设计风格</div>
                <div class="border">
                    <el-form-item class="form-item">
                        <el-select v-model="form.style" placeholder="设计风格" :popper-append-to-body="false"
                            :teleported="false" class="material-select" style="width: 100%;" filterable allow-create>
                            <el-option v-for="item in styleOptions" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </div>
                <div class="flex">
                    <div class="flex-border">
                        <div class="title">主色调</div>
                        <div class="border1">
                            <el-form-item class="form-item">
                                <el-select v-model="form.color" placeholder="主色调" :popper-append-to-body="false"
                                    :teleported="false" class="material-select" style="width: 100%;" filterable
                                    allow-create>
                                    <el-option v-for="item in colorOptions" :key="item" :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="flex-border">
                        <div class="title">门头材质</div>
                        <div class="border1">
                            <el-form-item class="form-item">
                                <el-select v-model="form.material" placeholder="门头材质" :popper-append-to-body="false"
                                    :teleported="false" class="material-select" style="width: 100%;" filterable
                                    allow-create>
                                    <el-option v-for="item in materialOptions" :key="item" :label="item"
                                        :value="item" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="flex">
                    <div class="flex-border">
                        <div class="title">门头字体</div>
                        <div class="border1">
                            <el-form-item class="form-item">
                                <el-select v-model="form.font" placeholder="门头字体" :popper-append-to-body="false"
                                    :teleported="false" class="material-select" style="width: 100%;" filterable
                                    allow-create>
                                    <el-option v-for="item in fontTypeOptions" :key="item" :label="item"
                                        :value="item" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="flex-border">
                        <div class="title">结构层数</div>
                        <div class="border1">
                            <el-form-item class="form-item">
                                <el-select v-model="form.structure" placeholder="结构层数" :popper-append-to-body="false"
                                    :teleported="false" class="material-select" style="width: 100%;" filterable
                                    allow-create>
                                    <el-option v-for="item in structureOptions" :key="item" :label="item"
                                        :value="item" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="title mt16">备注</div>
                <div class="border2">
                    <el-input v-model="form.brief" maxlength="30" style="width: 100%;height: 100%;"
                        placeholder="红黑配色/霓虹灯效果/虾" show-word-limit type="textarea" />
                </div>

                <div class="flex-col" @click="handleGenerateDesign" :class="{ 'loading': loading }">
                    <div class="col-title" v-if="!loading">立即生成</div>
                    <div class="col-title" v-else>生成中...</div>
                    <div class="col-brief">（生成消耗5积分）</div>
                </div>
            </div>
        </div>
        <div class="page-right">
            <div class="title">生成记录</div>
            <div class="line"></div>
            <div class="active"></div>
            <div class="list" v-loading="historyLoading">
                <template v-if="designHistory.length > 0">
                    <template v-for="(record, index) in designHistory" :key="record.id">
                        <div class="item-wrapper">
                            <div class="item">
                                <img class="item-logo" src="../images/logo.png" alt="">
                                <div class="item-title">一键设计门头</div>
                                <div class="item-time">{{ formatDate(record.created_at) }}</div>
                                <div class="item-border">清晰度 2k</div>
                                <div class="item-border">比例 3:4</div>
                            </div>
                            <div class="image-grid">
                                <img v-for="(image, imgIndex) in record.image_urls" :key="imgIndex" class="image"
                                    :src="image || 'https://mdn.alipayobjects.com/fecodex_image/afts/img/tn8-R60WTnEAAAAAR3AAAAgAejH3AQBr/original'" />
                            </div>

                            <div class="row">
                                <div class="d-box" @click="downloadDesign(record.id)">
                                    <img class="d-box-img" src="../images/d.png" alt="">
                                    <div class="d-box-title">下载</div>
                                </div>
                                <div class="d-box" @click="reeditDesign(record.id)">
                                    <img class="d-box-img" src="../images/edit.png" alt="">
                                    <div class="d-box-title">重新编辑</div>
                                </div>
                                <div class="d-box" @click="regenerateDesign(record.id)">
                                    <img class="d-box-img" src="../images/loading.png" alt="">
                                    <div class="d-box-title">重新生成</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <div v-else class="no-history">
                    <p>暂无历史记录</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, inject, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus';

// 获取store和provide
const store = useStore();
const openLoginDialog = inject('openLoginDialog', null);

// 页面逻辑
const form = ref({
    industry: '', // 行业类型
    style: '不限', // 设计风格
    color: '不限', // 主色调
    material: '不限', // 门头材质
    font: '不限', // 门头字体
    structure: '单层', // 结构层数
    brief: '' // 备注
})

// Loading 状态
const loading = ref(false);

// 自定义 loading 配置
const customLoadingOptions = {
    text: '图片正在生成中...',
    background: 'rgba(0, 0, 0, 0.7)',
    spinner: `<div class="custom-spinner"></div>`,
    lock: true,
    fullscreen: false
};

// 生成记录
const designHistory = ref([]);
const historyLoading = ref(false);

// 检查用户是否已登录
const checkLogin = async () => {
    if (!store.getters.isLoggedIn) {
        // 用户未登录，显示提示
        ElMessage({
            message: '暂未登录',
            type: 'warning',
            duration: 3000
        });

        // 打开登录弹窗
        if (openLoginDialog) {
            openLoginDialog('login');
        }
        return false;
    }
    return true;
}

// 获取生成记录
const fetchDesignHistory = async () => {
    historyLoading.value = true;
    try {
        const params = {
            limit: 10,
            offset: 0
        };
        const response = await store.dispatch('getDesignHistory', params);
        const newData = response.data.data || [];

        // 保留现有记录中的原始参数
        const existingRecordsMap = {};
        designHistory.value.forEach(record => {
            if (record.original_params) {
                existingRecordsMap[record.id] = record.original_params;
            }
        });

        // 将原始参数添加到新数据中
        newData.forEach(record => {
            if (existingRecordsMap[record.id]) {
                record.original_params = existingRecordsMap[record.id];
            }
        });

        designHistory.value = newData;
    } catch (error) {
        console.error('获取生成记录失败:', error);

        // 检查是否是因为用户未登录导致的错误
        if (error.status === 500) {
            ElMessage({
                message: '请先登录以查看生成记录',
                type: 'warning',
                duration: 3000
            });
        }

        designHistory.value = [];
    } finally {
        historyLoading.value = false;
    }
}

// 组件挂载时获取生成记录
onMounted(() => {
    fetchDesignHistory();
})

// 监听用户登录状态变化
watch(
    () => store.getters.isLoggedIn,
    (newVal, oldVal) => {
        // 如果用户刚登录（从false变为true），则获取生成记录
        if (newVal && !oldVal) {
            fetchDesignHistory();
        }
    }
);

// 格式化日期
const formatDate = (dateString) => {
    if (!dateString) return '未知时间';

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
}

// 下载设计作品
const downloadDesign = (designId) => {
    // 找到对应的设计记录
    const record = designHistory.value.find(item => item.id === designId);
    console.log(record);
    
    if (!record || !record.first_image_url) {
        ElMessage({
            message: '找不到设计作品或图片链接',
            type: 'error',
            duration: 3000
        });
        return;
    }

    try {
        // 直接下载图片到本地
        const link = document.createElement('a');
        link.href = record.image_url;
        link.setAttribute('download', `design-${designId}.png`);
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        ElMessage({
            message: '下载成功',
            type: 'success',
            duration: 3000
        });
    } catch (error) {
        console.error('下载失败:', error);
        ElMessage({
            message: '下载失败: ' + (error.message || '未知错误'),
            type: 'error',
            duration: 3000
        });
    }
}

// 获取门头名称输入框的值
const getShopName = () => {
    const shopNameInput = document.querySelector('.border-input');
    return shopNameInput ? shopNameInput.value : '';
}

// 设置门头名称输入框的值
const setShopName = (name) => {
    const shopNameInput = document.querySelector('.border-input');
    if (shopNameInput) {
        shopNameInput.value = name;
    }
}

// 重新编辑设计
const reeditDesign = async (designId) => {
    if (!(await checkLogin())) return;

    try {
        // 显示加载状态
        historyLoading.value = true;

        // 找到对应的记录
        const record = designHistory.value.find(item => item.id === designId);
        console.log(record);

        if (!record) {
            ElMessage({
                message: '找不到对应的记录',
                type: 'error',
                duration: 3000
            });
            return;
        }

        // 直接使用历史记录中的参数填充表单
        // 填充表单数据
        form.value.industry = record.industry || '';
        form.value.style = record.style || '';
        form.value.color = record.color || '';
        form.value.material = record.material || '';
        form.value.font = record.font || '';
        form.value.structure = record.structure || '';
        form.value.brief = record.brief || '';

        // 填充门头名称（如果存在）
        if (record.shop_name) {
            setShopName(record.shop_name);
        }

        ElMessage({
            message: '已加载历史记录到表单',
            type: 'success',
            duration: 3000
        });

    } catch (error) {
        console.error('重新编辑失败:', error);
        ElMessage({
            message: '重新编辑失败: ' + (error.response?.data?.message || error.message || '未知错误'),
            type: 'error',
            duration: 3000
        });
    } finally {
        historyLoading.value = false;
    }
}

// 重新生成设计
const regenerateDesign = async (designId) => {
    if (!(await checkLogin())) return;

    try {
        // 显示加载状态
        historyLoading.value = true;

        // 找到对应的记录
        const record = designHistory.value.find(item => item.id === designId);
        if (!record) {
            ElMessage({
                message: '找不到对应的记录',
                type: 'error',
                duration: 3000
            });
            return;
        }

        // 添加调试信息
        console.log('重新生成记录:', record);
        console.log('所有记录:', designHistory.value);

        // 使用立即生成的接口重新生成
        // 构造与立即生成完全相同的参数
        const requestData = {
            prompt: record.prompt,
            return_url: true,
            logo_info: { add_logo: false },
            width: 2304,
            height: 1728,
            req_key: 'jimeng_t2i_v40',
            form_data: {
                industry: record.industry || '',
                style: record.style || '',
                color: record.color || '',
                material: record.material || '',
                font: record.font || '',
                structure: record.structure || '',
                brief: record.brief || ''
            },
            shop_name: record.shop_name || ''
        };

        console.log('使用重构参数重新生成:', requestData);
        await handleGenerateDesignWithParams(requestData);

    } catch (error) {
        console.error('重新生成失败:', error);
        ElMessage({
            message: '重新生成失败: ' + (error.response?.data?.message || error.message || '未知错误'),
            type: 'error',
            duration: 3000
        });
    } finally {
        historyLoading.value = false;
    }
}

// 使用指定参数生成门头设计
const handleGenerateDesignWithParams = async (params) => {
    if (!(await checkLogin())) return;

    // 设置自定义 loading
    loading.value = customLoadingOptions;

    try {
        // 调用store action生成设计
        // 注意：超时控制已在 axios 配置中设置（30分钟），这里不再单独设置
        const response = await store.dispatch('generateDesign', params);

        console.log('生成门头设计成功:', response);

        // 生成成功后，重新获取用户信息以更新积分
        try {
            await store.dispatch('getCurrentUser');
            // 生成成功后提示
            ElMessage({
                message: '已扣除 5 积分',
                type: 'success',
                duration: 2000
            });
        } catch (error) {
            console.error('更新用户信息失败:', error);

            // 检查是否是因为用户未登录导致的错误
            if (error.message === '用户未登录') {
                ElMessage({
                    message: '请先登录以获取用户信息',
                    type: 'warning',
                    duration: 3000
                });
            }
        }

        // 存储原始参数以便重新生成时使用
        if (response && response.data) {
            // 重新获取生成记录以确保获取最新数据
            await fetchDesignHistory();

            // 将原始参数存储到最新的记录中
            if (designHistory.value.length > 0) {
                const latestRecord = designHistory.value[0];
                if (latestRecord) {
                    // 存储完整的参数以便重新生成时使用
                    latestRecord.original_params = { ...params };
                    console.log('存储原始参数到记录:', latestRecord.id, latestRecord.original_params);
                }
            }
        }

        // 生成成功后，重新获取生成记录
        try {
            await fetchDesignHistory();
        } catch (error) {
            console.error('更新生成记录失败:', error);
        }
        
    } catch (error) {
        console.error('生成门头设计失败:', error);
        
        // 使用拦截器设置的友好错误提示，或根据错误类型显示默认提示
        let errorMessage = error.friendlyMessage || '生成门头设计失败，请稍后重试';
        
        ElMessage({
            message: errorMessage,
            type: 'error',
            duration: 3000
        });
    } finally {
        // 重置loading状态
        loading.value = false;
    }
}

// 一键生成门头设计
const handleGenerateDesign = async () => {
    if (!(await checkLogin())) return;

    // 获取门头名称
    const shopName = getShopName();

    // 验证必填字段
    if (!shopName.trim()) {
        ElMessage({
            message: '请输入门头名称',
            type: 'warning',
            duration: 3000
        });
        return;
    }

    if (!form.value.industry) {
        ElMessage({
            message: '请选择行业类型',
            type: 'warning',
            duration: 3000
        });
        return;
    }

    if (!form.value.style) {
        ElMessage({
            message: '请选择设计风格',
            type: 'warning',
            duration: 3000
        });
        return;
    }



    // 检查积分是否足够（假设生成需要 10 积分）
    const requiredPoints = 10;
    const currentPoints = store.getters.userInfo?.points || store.getters.userInfo?.credit || 0;

    if (currentPoints < requiredPoints) {
        ElMessage({
            message: '积分不足，请先充值',
            type: 'warning',
            duration: 3000
        });
        return;
    }

    // 生成前提示 - 使用确认弹窗
    try {
        await ElMessageBox.confirm(
            '本次操作将消耗 5 积分，是否继续？',
            '积分扣除确认',
            {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }
        );
    } catch (cancelError) {
        // 用户点击取消或关闭弹窗
        return;
    }

    // 设置loading状态
    loading.value = true;

    try {
        // 构造prompt
        const structureText = form.value.structure !== '单层' ? form.value.structure : '';
        const materialText = form.value.material !== '不限' ? `门头材质${form.value.material}` : '';
        const fontText = form.value.font !== '不限' ? `字的材质是${form.value.font}` : '';
        const colorText = form.value.color !== '不限' ? `颜色${form.value.color}` : '';
        const styleText = form.value.style !== '不限' ? `设计风格${form.value.style}` : '设计风格现代简约';

        // const prompt = `${structureText}门店完整展示，门头比较长，门头造型丰富，商业街 ，门头名字：${shopName}，是一个${form.value.industry}，${materialText}，${fontText}，门头材质丰富，要配合灯箱，门头字体是${form.value.font !== '不限' ? form.value.font : '常规字体'}，设计一个logo，${styleText}，${colorText}，正角度拍摄，符合潮流，符合大众的审美,小众感，门头上加上slogan`;
        const prompt = `${structureText}单层临街门店完整展示，单层门店，门头造型有创意，商业街，门头名字叫：${shopName}，是一家${form.value.industry}，${materialText}，${fontText}，门头材质丰富，要配合灯箱，门头字体是${form.value.font !== '不限' ? form.value.font : '常规字体'}，设计一个logo，${styleText}，${colorText}，正角度拍摄，符合潮流，符合大众审美，小众感，符合${form.value.industry}的氛围，根据名字创意风格，门头上加上slogan`;
        // 构造请求数据，包含完整的表单数据
        const requestData = {
            prompt: prompt, 
            return_url: true,      // 必须开启
            logo_info: { add_logo: false },
            width: 2304,
            height: 1728,
            req_key: 'jimeng_t2i_v40',
            sequential_image_generation: "auto",
            sequential_image_generation_options: {
                max_images: 4
            },
            // 包含完整的表单数据
            form_data: {
                industry: form.value.industry,
                style: form.value.style,
                color: form.value.color,
                material: form.value.material,
                font: form.value.font,
                structure: form.value.structure,
                brief: form.value.brief
            },
            shop_name: shopName
        };

        // 调用带参数的生成函数
        await handleGenerateDesignWithParams(requestData);

        // 这里可以添加生成成功后的处理逻辑
        // 比如更新生成记录列表等
    } catch (error) {
        console.error('生成门头设计失败:', error);

        // 使用拦截器设置的友好错误提示，或根据错误类型显示默认提示
        let errorMessage = error.friendlyMessage || '生成门头设计失败，请稍后重试';

        ElMessage({
            message: errorMessage,
            type: 'error',
            duration: 3000
        });
    } finally {
        // 重置loading状态
        loading.value = false;
    }
}
// 行业列表
const industries = [
    '饭店', '烧烤店', '火锅店', '烤鱼店', '串串店',
    '小吃店', '快餐店', '早餐店', '粉面馆', '韩式料理店',
    '寿司店', '咖啡店', '茶馆', '酒吧', '饮品店',
    '披萨店', '融合餐厅', '奶茶店', '甜品店', '面包店',
    '服装店', '美容院', '美甲店', '超市', '茶叶店',
    '便利店', '水果店', '零食店', '药店', '理发店',
    '洗车店', '修车店', '广告店', '健身房', '宠物店',
    '酒店', '宾馆', '理疗店', '中医馆', '棋牌室', '采耳店'
];
// 风格选项
const styleOptions = [
    '不限', '现代风格', '新中式风格', '古典中式风格', '现代中式风',
    '民族风', '市井怀旧风', '工业风', '废墟风', '法式风',
    '复古风', '原木风', '露营风', '山野风', '国潮风', '朋克赛博风'
];

// 门头材质选项
const materialOptions = [
    '不限', '亚克力', '拉布灯箱', '格栅', '铝塑板', '不锈钢',
    '真石漆', '金属字', '木板', '防腐木', '喷绘布',
    '生态木', '刀刮布', '3M布灯箱'
];

// 门头字材质选项
const fontMaterialOptions = [
    '不限', '发光字', '背发光字', '3M灯箱布'
];

// 门头字体选项
const fontTypeOptions = [
    '不限', '手写艺术体', '方正字体', '艺术字', '变形字'
];

// 结构选项
const structureOptions = [
    '单层', '双层', '三层'
];
// 颜色选项
const colorOptions = [
    '不限', '红色', '绿色', '蓝色', '黄色',
    '白色', '灰色', '紫色', '橙色', '暖色', '冷色'
];
</script>

<style scoped>
.box {
    display: flex;
    align-items: center;
}

.item-wrapper {
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid #2B2C2C;
}

.item {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.item-logo {
    width: 24px;
    height: 24px;

}

.item-title {
    margin-left: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
}

.item-time {
    margin-left: 12px;
    font-family: Arial, Arial;
    font-weight: 400;
    font-size: 14px;
    color: #6A6B6E;
}

.item-border {
    margin-left: 12px;
    width: 59px;
    height: 22px;
    background: #2B2C2C;
    border-radius: 3px 3px 3px 3px;
    border: 1px solid #2B2C2C;
    font-family: Arial, Arial;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.row {
    display: flex;
    align-items: center;
}

.list {
    height: 80vh;
    overflow-y: scroll;
}

.no-history {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #6A6B6E;
    font-size: 16px;
    text-align: center;
}

.d-box {
    width: 112px;
    height: 32px;
    background: #17181A;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #2B2C2C;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    margin-top: 22px;
    margin-left: 8px;
}

.d-box:first-child {
    margin-left: 0px;
}

.d-box-img {
    width: 16px;
    height: 16px;
}

.d-box-title {
    font-family: Arial, Arial;
    font-weight: normal;
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 8px;
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin: 20px 0 0 38px;
    max-width: 1000px;
}

.image {
    width: 100%;
    aspect-ratio: 4/3;
    border-radius: 8px;
    object-fit: cover;
}

.page-left {
    width: 490px;
    height: 80vh;
    padding: 20px;
    box-sizing: border-box;
    background: #1D1D1D;
    border-radius: 16px 16px 16px 16px;
}

.page-right {
    flex: 1;
    margin-left: 16px;
    height: 80vh;
}

.line {
    width: 100%;
    margin-top: 16px;
    height: 0px;
    border: 1px solid #2B2C2C;
}

.active {
    width: 64px;
    height: 0px;
    border: 3px solid #5EFF00;
    font-size: 16px;
    margin-top: -6px;
}

.title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
}

.mt16 {
    margin-top: 10px;
}

.border {
    width: 450px;
    height: 38px;
    background: #2B2C2C;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #2B2C2C;
    margin-top: 10px;
}

.border-input {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 8px 8px 8px 8px;
    padding: 10px;
    box-sizing: border-box;
    outline: none;
    color: #fff;
    background: #2B2C2C;
}

.flex {
    display: flex;
    align-items: center;
    width: 100%;
}

.flex-border {
    width: 50%;
    margin-top: 10px;
}

.border1 {
    width: 217px;
    height: 38px;
    background: #2B2C2C;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #2B2C2C;
    margin-top: 10px;
}

.border2 {
    width: 450px;
    height: 68px;
    background: #2B2C2C;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #2B2C2C;
    margin-top: 10px;
}

.flex-col {
    width: 450px;
    height: 60px;
    background: #5EFF00;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #00FBFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    cursor: pointer;

}

.flex-col.loading {
    background: #cccccc;
    border-color: #999999;
    cursor: not-allowed;
}

.col-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #222222;
}

.col-brief {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #328800;
}

.page-left {
    /* 自定义 Element Plus 变量 */
    --el-fill-color-blank: #2B2C2C;
    --el-bg-color-overlay: #2B2C2C;
    --el-border-color: none;
    --el-text-color-regular: #fff;
    --el-border-color-hover: #555;
    --el-color-primary: #5EFF00;
    --el-fill-color-light: #666;
}

.border :deep(.el-input__wrapper) {
    background-color: var(--el-fill-color-blank) !important;
    border: none !important;
}

.border :deep(.el-input__inner) {
    color: var(--el-text-color-regular) !important;
}

/* 垂直滚动条 */
::-webkit-scrollbar {
    width: 12px;
    /* 垂直滚动条宽度 */
    height: 12px;
    /* 水平滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background: #090909;
    border-radius: 6px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #121212, #939292);
    border-radius: 6px;
}

/* 滑块悬停效果 */
::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #666, #444);
}

/* 水平滚动条滑块 */
::-webkit-scrollbar-thumb:horizontal {
    background: linear-gradient(90deg, #000000, #000000);
}

/* 角落 */
::-webkit-scrollbar-corner {
    background: #000000;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
    .box {
        flex-direction: column;
    }

    .page-left {
        width: 100%;
        height: auto;
        margin-bottom: 16px;
    }

    .page-right {
        width: 100%;
        margin-left: 0;
        height: auto;
    }

    .list {
        height: 400px;
    }

    .image-grid {
        margin: 16px 0 0 0;
        gap: 8px;
    }

    .image {
        width: 100%;
        aspect-ratio: 4/3;
    }

    .flex {
        flex-direction: column;
    }

    .flex-border {
        width: 100%;
        margin-right: 0;
    }

    .border1 {
        width: 100%;
    }

    .border,
    .border2 {
        width: 100%;
    }

    .flex-col {
        width: 100%;
    }

    .d-box {
        flex: 1;
        min-width: 80px;
        margin-left: 4px;
        margin-right: 4px;
    }

    .d-box:first-child {
        margin-left: 0;
    }

    .row {
        flex-wrap: wrap;
    }
}

/* 自定义 loading 样式 */
.custom-spinner {
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #5EFF00;
    animation: custom-spin 1s ease-in-out infinite;
}

@keyframes custom-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
